@switch (type()) {
  @case ('error') {
    <mat-icon class="tip-icon" svgIcon="icon-status-error" />
  }
  @case ('warning') {
    <mat-icon class="tip-icon" svgIcon="exclamation-mark-warning" />
  }
  @case ('complete') {
    <mat-icon class="tip-icon" svgIcon="icon-status-success" />
  }
  @default {
    <div class="tip-icon">
      <ng-content select="[tip-preffix], [tipPreffix]" />
    </div>
  }
}
<ng-content />

<div class="tip-suffix">
  <ng-content select="[tip-suffix], [tipSuffix]" />
</div>
@if (showCloseButton()) {
  <app-general-icon-button
    buttonIcon="close-thin"
    buttonStyle="inline"
    (buttonClicked)="closeTip()"
  />
}
